export const PAYMENT_METHOD = {
	PAY_ALL: 'PAY_ALL',
	PAY_DEPOSIT: 'PAY_DEPOSIT',
	USE_CURE: 'USE_CURE',
	USE_GIFT_VOUCHER: 'USE_GIFT_VOUCHER'
};
